import env from '../../../../environment';
import {
  getCreator,
  postCreator,
  deleteCreator,
  putCreator,
} from '../../../../http';

import type {
  TriggerFilterGroup,
  TriggerType,
  TriggerActionRequest,
} from '../../../../entities';

export const endpoints = Object.freeze({
  CREATE_TRIGGER: `${env.baseApiUrl}/im/admin/trigger`,
  GET_TRIGGERS: `${env.baseApiUrl}/im/admin/trigger`,
  GET_TRIGGER: `${env.baseApiUrl}/im/admin/trigger/:triggerId`,
  EDIT_TRIGGER: `${env.baseApiUrl}/im/admin/trigger/:triggerId`,
  DELETE_TRIGGER: `${env.baseApiUrl}/im/admin/trigger/:triggerId`,
  // Execution/simulate live under winehouse CRM (not im/admin trigger CRUD).
  GET_TRIGGER_EXECUTIONS: `${env.baseApiUrl}/winehouse/admin/crm/triggers/:triggerId/execution`,
  SIMULATE_TRIGGER_EXECUTION: `${env.baseApiUrl}/winehouse/admin/crm/triggers/:triggerId/execution/simulate`,
});

export const createTriggerEndpoint = postCreator(endpoints.CREATE_TRIGGER);
export const editTriggerEndpoint = putCreator(endpoints.EDIT_TRIGGER);
export const getTriggersEndpoint = getCreator(endpoints.GET_TRIGGERS);
export const deleteTriggerEndpoint = deleteCreator(endpoints.DELETE_TRIGGER);
export const getTriggerEndpoint = getCreator(endpoints.GET_TRIGGER);
export const getTriggerExecutionsEndpoint = getCreator(
  endpoints.GET_TRIGGER_EXECUTIONS
);
export const simulateTriggerExecutionEndpoint = postCreator(
  endpoints.SIMULATE_TRIGGER_EXECUTION
);

export type CreateTriggerRequest = {
  name: string,
  /** UTC `HH:MM` (24h). Required for CUSTOMER_INACTIVITY triggers. */
  executionTime?: string,
  triggerType?: TriggerType,
  filters: TriggerFilterGroup[],
  actions: TriggerActionRequest[],
};

export type UpdateTriggerRequest = {
  name?: string,
  /** UTC `HH:MM` (24h). */
  executionTime?: string,
  filters?: TriggerFilterGroup[],
  enabled?: boolean,
  actions?: TriggerActionRequest[],
};

export type ListTriggersParams = {
  name?: string,
  trigger_type?: TriggerType,
  funnel_id?: string,
  tag_id?: string,
  page?: number,
  size?: number,
};

export type ListTriggerExecutionsParams = {
  page?: number,
  size?: number,
};
